<template >


  <div class="httpError text-center">
    <div class="container-fluid content">

      <!-- <p
        v-if="payload && payload.httpStatusCode"
        class="font-weight-normal">{{ $t("HTTP_ERROR."+ payload.httpStatusCode) }}</p> -->
      <p class="font-weight-normal">{{ $t("HTTP_ERROR.NO_RESPONSE") }}</p>

      <!-- <ActionButton
        class-name="btn btn-lg btn-primary btn-block"
        @click="refresh">{{ $t("HTTP_ERROR.REFRESH_TEXT") }}</ActionButton> -->
      <!-- <TextLink
        to="/"
        class-name="d-block mt-2 mb-2 baseColor">{{ $t("HTTP_ERROR.REFRESH_TEXT") }}</TextLink> -->
      <ActionButton
        class-name="btn btn-lg btn-primary btn-block"
        @click="home">{{ $t("HTTP_ERROR.HOME_TEXT") }}</ActionButton>

    </div>

  </div>

</template>

<script>
import TextLink from '@/components/Utils/TextLink';
import ActionButton from '@/components/Actions/ActionButton';

export default {
  name: 'HttpError',
  components: {
    TextLink,
    ActionButton,
  },
  // props: ["payload"],

  created() {
    return {
      email: '',
    };
  },
  methods: {
    home() {
      this.$router.push('/');
    },
    refresh() {
      window.location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.httpError {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
  &.actions {
    text-align: right;
  }
}
.logo {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  background-color: $primary;
  width: 175px;
  margin-left: auto;
  margin-right: auto;
}
</style>
